module.exports = __webpack_public_path__ + "static/media/lowest_cash_fund_fee.d5a9a2fe.svg";